import { getAssetUrl, getSourcingAssetUrl } from "../../utils/common";

export const LOW_STOCK_THRESHOLD = 3;

export const SORT_BY_CATEGORIES = {
  WHATS_NEW: "recent",
  ON_SALE: "sale",
  PRICE_LOW_TO_HIGH: "price_low",
  PRICE_HIGH_TO_LOW: "price_high",
  POPULARITY: "popularity",
};

/** PLP quick-filter chip order and product card visual tag badge (higher index = lower precedence for single badge). */
export const VISUAL_TAG_PRECEDENCE = [
  "Reward Eligible",
  "New Brands Live",
  "New Drops",
  "Going Viral",
  "Creator Favourite",
  "Brand Bestsellers",
  "Budget Finds",
  "Hidden Gems",
];

/** Tag → background color (Figma Shopping Design system 3370:10818 + 3370:10819). Text is always white. */
export const VISUAL_TAG_COLOR_MAP = {
  "New Drops": "#FF6600",
  "Going Viral": "#9241DC",
  "Creator Favourite": "#FA3A77",
  "Brand Bestsellers": "#0ABF77",
  "Budget Finds": "#1489FF",
  "Hidden Gems": "#BB6302",
  "New Brands Live": "#CC0A38",
  "Reward Eligible": "#1B873F",
};

/** Tag → leading icon name (FA). Keeps the pill consistent with PLPProductCard trendy/bestseller variants. */
export const VISUAL_TAG_ICON_MAP = {
  "New Drops": "fa-solid fa-bolt",
  "Going Viral": "fa-solid fa-fire",
  "Creator Favourite": "fa-solid fa-heart",
  "Brand Bestsellers": "fa-solid fa-crown",
  "Budget Finds": "fa-solid fa-tag",
  "Hidden Gems": "fa-solid fa-gem",
  "New Brands Live": "fa-solid fa-bolt",
  "Reward Eligible": "fa-solid fa-gift",
};

export const HeaderButtonStyle = {
  backgroundColor: "rgba(255, 255, 255, 0.7)",
  borderRadius: "1.1rem",
};

export const HeaderButtonStyleOpaque = {
  backgroundColor: "#fff",
  borderRadius: "1.1rem",
};

export const initialParameters = {
  collectionId: 0,
  brandId: 0,
  subcategoryId: 0,
};

export const sortByOptionsInitialState = [
  {
    label: "What's New",
    value: SORT_BY_CATEGORIES.WHATS_NEW,
    icon_url: getAssetUrl("star-outline.svg"),
  },
  // {
  //   label: "On Sale",
  //   value: SORT_BY_CATEGORIES.ON_SALE,
  //   icon_url: getAssetUrl("sale_coupon.svg"),
  // },
  {
    label: "Price - low to high",
    value: SORT_BY_CATEGORIES.PRICE_LOW_TO_HIGH,
    icon_url: getAssetUrl("rupee_up.svg"),
  },
  {
    label: "Price - high to low",
    value: SORT_BY_CATEGORIES.PRICE_HIGH_TO_LOW,
    icon_url: getAssetUrl("rupee_down.svg"),
  },
  {
    label: "Popularity",
    value: SORT_BY_CATEGORIES.POPULARITY,
    icon_url: getAssetUrl("sourcing_plain.svg"),
  },
];

export const filterOptionsInitialState = [
  {
    label: "Size",
    value: "size",
    options: [],
  },
  {
    label: "Colour",
    value: "colour",
    options: [],
  },
  {
    label: "Brand",
    value: "brand",
    options: [],
  },
  {
    label: "Categories",
    value: "categories",
    options: [],
  },
  {
    label: "Discount",
    value: "discount",
    options: [],
  },
  {
    label: "Price",
    value: "price",
    options: [],
  },
  {
    label: "Tags",
    value: "tags",
    options: [],
  },
  {
    label: "Gender",
    value: "gender",
    options: [],
  },
  // PRD Filters (SEL-1345): live trends (hero + PLP) as a filter value. Slot 8 —
  // the backend parser is positional, so this index is part of the contract.
  {
    label: "Trends",
    value: "trends",
    options: [],
  },
];

// Sidebar display order: Gender(7), Trends(8), Categories(3), Size(0), Brand(2), Discount(4), Price(5), Tags(6)
// Trends last: it sits right before "More Filters" in the drawer.
export const FILTER_DISPLAY_ORDER = [7, 3, 0, 2, 4, 5, 6, 8];
export const MORE_FILTERS_INDEX = -1;
export const FILTERS_WITH_SEARCH = [0, 2, 3];
export const attributeFiltersSelectedInitialState = {};

export const filterOptionsSelectedInitialState = [
  {
    value: "size",
    options: [],
  },
  {
    value: "colour",
    options: [],
  },
  {
    value: "brand",
    options: [],
  },
  {
    value: "categories",
    options: [],
  },
  {
    value: "discount",
    options: [],
  },
  {
    value: "price",
    options: [],
  },
  {
    value: "tags",
    options: [],
  },
  {
    value: "gender",
    options: [],
  },
  {
    value: "trends",
    options: [],
  },
];

export const SourcingCartActions = {
  ADD_TO_CART: "ADD_TO_CART",
  REMOVE_FROM_CART: "REMOVE_FROM_CART",
  MOVE_TO_WISHLIST: "MOVE_TO_WISHLIST",
};

export const SourcingCartPages = {
  ADD_PRODUCTS: "Add Products",
  SELECT_ADDRESS: "Select address",
  PLACE_REQUEST: "Place request",
};

export const DeliveryStatus = {
  RECEIVED: "received",
  ORDERED: "ordered",
  CANCELLED: "cancelled",
  SHIPPED: "shipped",
  DELIVERED: "delivered",
  DELIVERY_DELAYED: "delivery_delayed", // Status ID: 37
  DELIVERY_FAILED: "delivery_failed", // Status ID: 36
  DELIVERY_FAILED_AND_DEAD: "delivery_failed_and_dead", // Status IDs: 15, 16, 17, 33, 39, 40, 45, 46, 53, 87, 88, 9
  OUT_FOR_DELIVERY: "out_for_delivery", // Status ID: 19
  RETURN_REQUESTED: "return_requested", // Special case - no status_id in data
  RETURN_INITIATED: "return_initiated", // Status ID: 22
  RETURN_OUT_FOR_PICKUP: "return_out_for_pickup", // Status ID: 47
  RETURN_PICKED_UP: "return_picked_up", // Not in new data, kept for backward compatibility
  RETURN_FAILED_X: "return_failed_x", // Status IDs: 49, 50 - Transient state: pickup exception, can retry
  RETURN_FAILED_AND_DEAD: "return_failed_and_dead", // Status IDs: 27, 30, 57 - Terminal state: all pickup attempts exhausted
  RETURNED: "returned", // Status IDs: 25, 26, 32
  MANUAL_ORDER_CANCELLED: "manual_order_canceled",
  MANUAL_ORDER_RECEIVED: "manual_order_received",
};

export const CollabOrdersDeliveryStatus = {
  RECEIVED: "received",
  ORDERED: "ordered",
  CANCELLED: "cancelled",
  SHIPPED: "shipped",
  OUT_FOR_DELIVERY: "out_for_delivery",
  DELIVERED: "delivered",
  DELIVERY_FAILED: "delivery_failed",
  DELIVERY_FAILED_AND_DEAD: "delivery_failed_and_dead",
  RETURNED: "returned",
  UPLOAD_INVOICE: "upload_invoice",
};

export const MyOrdersTimeFilters = {
  THIS_MONTH: "This Month",
  TODAY: "Today",
  YESTERDAY: "Yesterday",
  LAST_7_DAYS: "Last 7 days",
  LAST_MONTH: "Last month",
  LAST_3_MONTHS: "Last 3 months",
  ALL_TIME: "All time",
};

export const MyOrdersTimeFilterDefault = MyOrdersTimeFilters.ALL_TIME;
export const SIZE_ORDER = ["XXS", "XS", "S", "M", "L", "XL", "XXL"];

export const CREDIT_TYPES = {
  SOURCING: "sourcing",
  BARTER: "barter",
  BRANDS: "brands",
  NONE: "none",
};

export const CREDIT_CONDITIONS = {
  SOURCING: "Sourcing",
  BARTER: "Barter",
  BOTH: "Both",
};

export const videoForBarter = "W8BETqZF-4o";
export const videoForWithoutBarter = "5orkC4jJyvI";

export const MANUAL_ORDER_CANCELLED_REASON = "Credit Limit exceeded";

export const SOURCING_REVOKE_ARRAY = [
  {
    id: 2,
    title: "Due to suspicious activity from your account.",
    subtitle: "Reach out to +91 9319007907 to know more! 📜",
    showSubtitleHeader: false,
  },
  {
    id: 3,
    title:
      "Since Telegram doesn't require content creation. Therefore, there's no need for you to source products.🚫",
    subtitle:
      "✅ Create content on Instagram/YouTube & qualify for Sourcing next month",
    showSubtitleHeader: true,
  },
  {
    id: 4,
    title: "As you are not posting any content on Wishlink since February",
    subtitle:
      "✅  Create more than 3 engaging content on Wishlink & start earning again via Wishlink💰",
    showSubtitleHeader: true,
  },
  {
    id: 5,
    title:
      "🚩Because you have sourced products but not posted content for products delivered till 4th March",
    subtitle: "✅ Post content for all sourced products to get access back",
    showSubtitleHeader: true,
  },
  {
    id: 6,
    title: "🚩Due to low sales generated via Wishlink Sourcing",
    subtitle: `Boost your earnings by:
      ✅ Sharing Wishlinks on stories & broadcast channel
      ✅ Create and post content of your sourced products`,
    showSubtitleHeader: true,
  },
];

export const SOURCING_STEPS = [
  {
    step_number: 1,
    title: "Cross ₹2.5 Lakh in non-Meesho sales",
    subtitle: "Effective from Jan 2025",
    icon: "sourcing-work-1.png",
  },
  {
    step_number: 2,
    title: "Post 5 non-Meesho content pieces ",
    subtitle: "Effective from Jan 2025",
    icon: "sourcing-work-2.png",
  },
  {
    step_number: 3,
    title: "Once you reach the milestone, access will be granted within 7 days",
    subtitle: "",
    icon: "sourcing-work-3.png",
  },
  {
    step_number: 4,
    title: "You will be notified once you get sourcing access",
    subtitle: "",
    icon: "sourcing-work-4.png",
  },
];

export const SOURCING_ACCESS_STEPS = [
  {
    step_number: 1,
    title: "Create content and share your wishlinks",
    subtitle: "",
    icon: "retain-access-1.png",
  },
  {
    step_number: 2,
    title: "Drive high sales on your sourced products",
    subtitle: "Atleast 7X sales of your sourced product amount",
    icon: "retain-access-2.png",
  },
  {
    step_number: 3,
    title: "Return your sourced product in 14 days",
    subtitle: "",
    icon: "retain-access-3.png",
  },
];

export const SOURCING_ANSWERS = [
  {
    icon: "sourcing-faq-1.png",
    title: "Sourcing Access",
    subtitle: "Track orders, delivery and return timeline",
    redirect_url: "/faq/5",
  },
  {
    icon: "sourcing-faq-2.png",
    title: "My Order",
    subtitle: "Check eligibility for sourcing products",
    redirect_url: "/faq/5",
  },
  {
    icon: "sourcing-faq-3.png",
    title: "Credits",
    subtitle: "Learn more about credits",
    redirect_url: "/faq/5",
  },
  {
    icon: "sourcing-faq-4-final.png",
    title: "Sourcing Guidelines",
    subtitle: "Guidelines for sourcing products",
    redirect_url: "/faq/5",
  },
];

export const GET_SOURCING_ACCESS_MINI = [
  {
    step_number: 1,
    title: "Cross ₹2.5 Lakh in non-Meesho sales",
    subtitle: "Effective from Jan 2025",
    icon: "sourcing-work-1.png",
  },
  {
    step_number: 2,
    title: "Post 5 non-Meesho content pieces ",
    subtitle: "Effective from Jan 2025",
    icon: "sourcing-work-2.png",
  },
  {
    step_number: 3,
    title: "Once you reach the milestone, access will be granted within 7 days",
    subtitle: "",
    icon: "sourcing-work-3.png",
  },
  {
    step_number: 4,
    title: "You will be notified once you get sourcing access",
    subtitle: "",
    icon: "sourcing-work-4.png",
  },
];

export const SOURCING_REVOKE_REASONS = [
  {
    step: 1,
    title: "You are not creating content on Wishlink actively",
  },
  {
    step: 2,
    title: "You have not created content on previously sourced products",
  },
  {
    step: 3,
    title: "You have not returned sourced products",
  },
  {
    step: 4,
    title: "You have driven low sales from sourced products",
  },
  {
    step: 5,
    title: "We detected suspicious activity on your account",
  },
];

export const SHOW_CONTENT_STATUS = [
  "Delivered",
  "Return Initiated",
  "Returned",
  "Return Failed",
  "Return Picked up",
  "Return Requested",
  "Return Confirmed",
  "Return Cancelled",
  "Return Out for Pickup",
  "Return Pickup Unsuccessful",
  "Return Successful",
  "Return QC Failed",
];

export const CONTENT_DELIVERY_STATUS = [
  "delivered",
  "return_initiated",
  "return_picked_up",
  "return_failed_x",
  "return_failed_and_dead",
  "returned",
];

export const TO_BE_RETURNED_STATUS = ["return_initiated"];

export const SOURCING_CART_ENTRYPOINT = {
  BANNER: "BANNER",
  BRAND: "BRAND",
  CATEGORY: "CATEGORY",
  COLLECTION: "COLLECTION",
  SEARCH: "SEARCH",
  WISHLIST: "WISHLIST",
};

export const SOURCING_MAINTENANCE_DATA = {
  MAINTENANCE: {
    imgUrl: getSourcingAssetUrl("sourcing-order-confirmation-graphic.svg"),
    title: "We are cooking something exciting!",
    description:
      "Sourcing is taking a quick break while we prep something new and improved just for you. Hang tight — we promise it'll be worth the wait.",
  },
  REFRESH: {
    imgUrl: getSourcingAssetUrl("sourcing-order-confirmation-graphic.svg"),
    title: "Experience New Sourcing!",
    description: (
      <>
        We've upgraded your sourcing experience! To unlock the latest updates,
        please <strong>fully close the app and re-open again.</strong>
      </>
    ),
  },
};

export const SOURCING_ACCESS_TEXTS = {
  SCREEN_1: {
    title: (
      <span>
        Get{" "}
        <strong>
          {Array.from("credits").map((char, i) => (
            <span key={i} data-text={char}>
              {char}
            </span>
          ))}
        </strong>{" "}
        to
        <br />
        <strong>
          {Array.from("Source").map((char, i) => (
            <span key={i} data-text={char}>
              {char}
            </span>
          ))}
        </strong>{" "}
        product
        <br />
        for your
        <br />
        content
      </span>
    ),
    subtitle:
      "Personalized platform to source products hassle-free from top D2C brands for creating your content on a returnable basis",
    note: "Note : All products sourced are to be returned to get back credits",
    note2: "Note : Connect your social media accounts to get sourcing",
  },
  SCREEN_2: {
    title: (
      <span>
        <strong>
          {Array.from("Return").map((char, i) => (
            <span key={i} data-text={char}>
              {char}
            </span>
          ))}
        </strong>
        <br />
        products to get
        <br />
        back the credit
        <br />
        to source again
      </span>
    ),
    subtitle: "Every brand has different time window to return products",
    note: "Note : If any products not returned, your credits will be deducted",
  },
  SCREEN_3: {
    title: (
      <span>
        Achieve{" "}
        <strong>
          {Array.from("milestone").map((char, i) => (
            <span key={i} data-text={char}>
              {char}
            </span>
          ))}
        </strong>
        <br />
        to get credits
      </span>
    ),
    note: "Note : Complete your milestone to get the access",
  },
  SCREEN_4: {
    title: "you claimed",
    note: "Note : All products sourced are to be returned to get back credits",
  },
};

export const GMV_REQUIRED_FOR_SOURCING_ACCESS = 250000;
export const POSTS_REQUIRED_FOR_SOURCING_ACCESS = 5;

export const SOURCING_CREDIT_TYPE = {
  SOURCING: "sourcing",
  BRAND_SOURCING: "brand-sourcing",
};

export const MANUAL_SOURCING_BRAND_IDS = [251, 303, 227];
